import React, { useEffect, useState } from "react";
import { AppRouteUi } from "../../configs";
import { useFunctionalityOperatorProfile } from "../../pages/hooks/functionalityOperatorProfile";

type Props = {
  operatorId?: string;
};

export function OperatorTranscriptionToggle({ operatorId }: Props) {
  const selectedOperatorId =
    operatorId ? operatorId : AppRouteUi.Operator.Profile.useParam();
  const { transcriptionToggleData, onUpdateTranscriptionEnabled } =
    useFunctionalityOperatorProfile({ operatorId: selectedOperatorId });
  const [localEnabled, setLocalEnabled] = useState<boolean>(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    setLocalEnabled(!!transcriptionToggleData?.isTranscriptionEnabled);
  }, [transcriptionToggleData?.isTranscriptionEnabled]);

  const handleToggle = () => {
    if (isUpdating) return;
    const nextValue = !localEnabled;
    setLocalEnabled(nextValue);
    setIsUpdating(true);
    onUpdateTranscriptionEnabled(nextValue)
      .catch(() => {
        setLocalEnabled(!nextValue);
      })
      .finally(() => setIsUpdating(false));
  };

  return (
    <div className="component-card mb-3">
      <div className="component-card-header d-flex align-items-center justify-content-between border-start border-top border-end ">
        <div>OPI Transcription</div>
      </div>
      <div className="component-card-body border">
        <div className="row flex-wrap px-3">
          <div className="col-12 px-0 col-min-width">
            <button
              type="button"
              className={`${localEnabled ? "btn btn-toggle active" : "btn btn-toggle"} operator-transcription-toggle-btn`}
              onClick={handleToggle}
              disabled={isUpdating}
            >
              <div className="handle"></div>
            </button>
            <span className="toggle-button-label">
              Enable OPI transcription
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
